var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-warp",style:({'height':''+_vm.windowWidth+'px'})},[_c('div',{staticClass:"banner",style:({'background':''+_vm.bannerColor+''})},[_c('div',{staticClass:"in",style:([_vm.style])})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-316e4666","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/home1.vue
// module id = null
// module chunks = 